export enum COLORS {
	LightGray = '#EAEDED',
	Gray = '#f3f6f6',
	DarkGray = '#868A8A',
	Black = '#272727',
	Text = '#2E3434',
	TextGray = '#868383',
	TextOpaque = 'rgba(46, 52, 52, 0.6)',
	Error = '#D95C35',
	ErrorShadow = 'rgba(217, 92, 53, 0.2)',
	Transparent = 'transparent',
	White = '#fff'
}
